import { useQualifyingQualifyingModalStore } from "@forwardflow/store/modal";
import { Modal } from "antd";

export const RemoveQualifyingQuestionModal = ({
   onDelete,
}: {
   onDelete: () => void;
}) => {
   const { isRemoveQualifyingModalOpen, closeRemoveQualifyingModal } =
      useQualifyingQualifyingModalStore();
   return (
      <>
         <Modal
            className="ff-modal"
            title="Remove Question Permanently"
            open={isRemoveQualifyingModalOpen}
            onCancel={closeRemoveQualifyingModal}
            footer={null}
         >
            <p className="mt-5 mb-14">
               Are you sure you want to remove this qualifying question?
            </p>
            <button
               onClick={() => (onDelete(), closeRemoveQualifyingModal())}
               className="w-full h-12 font-semibold transition-all border rounded bg-danger/20 hover:bg-danger/50 border-danger"
            >
               Remove question
            </button>
            <button
               onClick={closeRemoveQualifyingModal}
               className="w-full h-12 mt-2 font-semibold transition-all border rounded border-white/20 hover:bg-white/10"
            >
               Cancel
            </button>
         </Modal>
      </>
   );
};
